
export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
export const RESET_NOTIFICATION = 'RESET_NOTIFICATION';

export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE';
export const CHANGE_NAV_ITEM = 'CHANGE_NAV_ITEM';
export const ENVIRONMENT = 'ENVIRONMENT';
export const CHANGE_TOPBANNER = 'CHANGE_TOPBANNER';
export const CHANGE_HOMESECTION = 'CHANGE_HOMESECTION';

export const SET_SEARCH_KEY = 'SET_SEARCH_KEY';
export const INITIALIZE_SEARCH_KEY = 'INITIALIZE_SEARCH_KEY';

export const SET_BUSINESS = 'SET_BUSINESS';

export const SET_GLOBAL_SEARCH_KEY = 'SET_GLOBAL_SEARCH_KEY';

export const SET_BLOG_BUSINESS = 'SET_BLOG_BUSINESS';

export const INITIALIZE_BLOG_BUSINESS = 'INITIALIZE_BLOG_BUSINESS';

export const SET_SIDE_ACTIVITIES = 'SET_SIDE_ACTIVITIES';
export const INITIALIZE_SIDE_ACTIVITIES = 'INITIALIZE_SIDE_ACTIVITIES';
